import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CornerRightUp = createReactComponent("CornerRightUp", ["svg", defaultAttributes, [["polyline", {
  points: "10 9 15 4 20 9",
  key: "j9ek3k"
}], ["path", {
  d: "M4 20h7a4 4 0 004-4V4",
  key: "6vjwt7"
}]]]);
export default CornerRightUp;